import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText, CheckCircle2, AlertCircle, Scale } from "lucide-react";

export default function TermsConditionsPage() {
  return (
    <div className="space-y-6 animate-fade-in max-w-4xl mx-auto" data-testid="terms-page">
      {/* Top Header with Back Navigation */}
      <div className="flex items-center justify-between">
        <Link
          to="/calendar"
          data-testid="terms-back-btn"
          className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold text-pink-900 hover:text-pink-950 bg-white px-4 py-2 rounded-xl border border-pink-200 shadow-sm transition-all"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Calendar</span>
        </Link>

        <span className="text-xs font-semibold text-gray-500">
          Legal & Compliance
        </span>
      </div>

      {/* Main Container Card */}
      <div className="bg-white rounded-3xl border border-pink-100 shadow-xl overflow-hidden">
        {/* Banner */}
        <div className="bg-gradient-to-r from-pink-900 via-pink-800 to-rose-800 p-6 sm:p-8 text-white">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/20 text-xs font-semibold mb-2">
            <Scale className="w-3.5 h-3.5 text-pink-200" />
            <span>Terms of Service</span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-black tracking-tight">
            Terms & Conditions
          </h1>
          <p className="text-pink-100 text-xs sm:text-sm mt-1 max-w-xl">
            Guidelines and legal agreements governing the use of BookMyEvents business portal and convention hall management services.
          </p>
        </div>

        {/* Content Body */}
        <div className="p-6 sm:p-8 space-y-6 bg-white text-xs sm:text-sm text-gray-700 leading-relaxed">
          
          <section className="space-y-2">
            <h2 className="text-sm sm:text-base font-bold text-pink-950 flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4 text-pink-700" />
              <span>1. Acceptance of Terms</span>
            </h2>
            <p>
              By accessing and using BookMyEvents, you agree to be bound by these Terms and Conditions and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this platform.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-sm sm:text-base font-bold text-pink-950 flex items-center gap-2">
              <FileText className="w-4 h-4 text-pink-700" />
              <span>2. Venue Ownership & Invoicing</span>
            </h2>
            <p>
              Convention hall owners are solely responsible for ensuring the accuracy of all booking slots, pricing figures, tax percentages (such as 18% GST), and invoice receipts generated for clients. BookMyEvents functions as a management portal and record keeper.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-sm sm:text-base font-bold text-pink-950 flex items-center gap-2">
              <AlertCircle className="w-4 h-4 text-pink-700" />
              <span>3. Cancellations & Advance Payments</span>
            </h2>
            <p>
              Disputes regarding booking cancellations, refund of advance tokens, caution deposits, or electricity charges must be resolved directly between the venue owner and the customer according to the venue's individual written agreement.
            </p>
          </section>

          <div className="pt-4 border-t border-gray-100 text-[11px] text-gray-400">
            Version 2.4 • Effective March 2025 • Bharath Developers
          </div>
        </div>
      </div>
    </div>
  );
}
